<template>
  <!-- 一括支払（買掛金）登録 -->
  <div class="egl-dialog-elm">
    <el-dialog
      :title="$locale('accountPayable.oneTimePaymentRegistration2')"
      :visible="isShow"
      class="egl-dialog payment-registration-dialog"
      :modal="false"
      :before-close="closeDialog"
      :modal-append-to-body="true"
      :show-close="true"
      :close-on-click-modal="false"
    >
      <el-form label-position="top">
        <div class="module-item">
          <div class="module-item-tit">{{ $locale("global.basicInfo") }}</div>
          <el-row :gutter="25">
            <el-col :span="5">
              <el-form-item :label="`${$locale('accountPayable.paymentName')}*`">
                <el-input v-model="form.name" :placeholder="$locale('accountPayable.placeholder.paymentName')" @input="setSaveBtn"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="`${$locale('accountPayable.paymentDate')}*`">
                <CommDatePicker
                  v-model="form.date"
                  :value.sync="form.date"
                  width="100%"
                  :showWeekly="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="`${$locale('accountPayable.paymentCategory')}1*`">
                <el-select v-model="form.type" @change="changeType">
                  <el-option
                    v-for="item in typeOption"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="`${$locale('accountPayable.paymentCategory')}2*`">
                <el-select v-model="form.typeDetail" @change="changeTypeDetail">
                  <el-option
                    v-for="item in typeDetailOption"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="`${$locale('accountPayable.paymentTotal')}*`">
                <el-input v-model="paymentTotal" :placeholder="$locale('accountPayable.placeholder.paymentTotal')" @input="setSaveBtn" @blur="blurPaymentTotal"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="13" v-if="form.type == 'OFFSET'">
              <el-form-item>
                <el-select v-model="form.payOffset.offsetDetailId" @change="changePayOffset">
                  <el-option
                    v-for="(item, index) in payOffsetOption"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="module-item">
          <div class="module-item-tit">{{ $locale("accountPayable.oneTimePayment") }}</div>
          <el-table
            :data="tableData"
            class="egl-table list-table"
            stripe
            :cell-class-name="setCellClassName"
            :span-method="spanMethod"
            @selection-change="selectTr"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column :label="$locale('global.type')" prop="typeText"></el-table-column>
            <el-table-column :label="$locale('accountPayable.accountPayableDetail')" prop="name"></el-table-column>
            <el-table-column :label="$locale('accountPayable.th.requestDeadDate')" prop="requestDeadDateText"></el-table-column>
            <el-table-column :label="$locale('accountPayable.th.paymentDueDate')" prop="paymentDueDateText"></el-table-column>
            <el-table-column :label="$locale('accountPayable.th.recordAmount')">
              <template slot-scope="scope">{{ scope.row.needPayAmount.toLocaleString() }}</template>
            </el-table-column>
            <el-table-column :label="$locale('accountPayable.th.amountPaid')">
              <template slot-scope="scope">{{ scope.row.payAmount.toLocaleString() }}</template>
            </el-table-column>
            <el-table-column :label="$locale('accountPayable.th.accountPayableBalance')">
              <template slot-scope="scope">{{ scope.row.actualAmountResidual.toLocaleString() }}</template>
            </el-table-column>
            <el-table-column :label="$locale('accountPayable.adjustment')">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.adjustment"
                  readOnly
                  v-if="scope.$index != tableData.length - 1"
                  class="disable-input"
                  @focus="openPaymentDetailDialog(scope.$index)"
                ></el-input>
                <span v-else>{{ scope.row.adjustment.toLocaleString() }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$locale('accountPayable.otherOffset')">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.offset.payAmount"
                  readOnly
                  v-if="scope.$index != tableData.length - 1"
                  class="disable-input"
                  @focus="openPaymentDetailDialog(scope.$index)"
                ></el-input>
                <span v-else>{{ scope.row.offset.payAmount.toLocaleString() }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$locale('accountPayable.payMoney')">
              <template slot-scope="scope">{{ scope.row.payMoney.toLocaleString() }}</template>
            </el-table-column>
          </el-table>

          <div class="table-total">
            <div class="clearfix">
              <span>{{ $locale("accountPayable.payMoneyTotal") }}</span>
              <span>{{ payMoneyTotal.toLocaleString() }}</span>
            </div>
            <div class="clearfix">
              <span>{{ $locale("accountPayable.paymentAmountDifference") }}</span>
              <span :class="payMoneyTotalDiff < 0 ? 'red-text' : ''">{{ ( payMoneyTotalDiff).toLocaleString() }}</span>
            </div>
            <div class="clearfix">
              <span>{{ $locale("accountPayable.threeTotal") }}</span>
              <span>{{ threeTotal.toLocaleString() }}</span>
            </div>
          </div>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button class="egl-btn-white" @click="closeDialog">{{ $locale("global.cancel") }}</el-button>
        <el-button :class="saveBtnDisabled ? 'egl-btn-gray' : 'egl-btn-yellow'" @click="save_fn" :disabled="saveBtnDisabled">{{ $locale("global.save") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommDatePicker from "@/components/common/CommDatePicker";
import {
  createPaymentForm,
  createPaymentTypeOption,
  formatOneTimePaymentTableData,
  createTypeList,
  getKeyNames,
} from "@/assets/js/accountPayable.js";
import { createAccountPayablePayment, getBankAccountList, getAccountReceivableListMap } from "@/helpers/service/api/accountPayable.js";
import { mapState, mapActions } from "vuex";

export default {
  name: "AccountPayableOneTimePayment",
  data() {
    return {
      form: createPaymentForm(),
      tableData: [],
      typeOption: createPaymentTypeOption(),
      typeDetailOption: [],
      paymentTotal: "",
      payMoneyTotal: 0,
      payMoneyTotalDiff: 0,
      threeTotal: 0,
      saveBtnDisabled: true,
      typeList: createTypeList(),
      accountReceivableOption: [],
      payOffsetOption: [],
      tableSelectedId: [],
      initTable: [],
    };
  },
  computed: {
    ...mapState("app", { brandId: state => state.brandId, accountReceivablePar: state => `brandId=${state.brandId}&page=0&pageSize=9999&field=name&field=id&field=needPayAmount&field=targetSourceList&field=clientId` }),
  },
  methods: {
    ...mapActions("api", ["setInvoiceList"]),
    closeDialog() {
      this.$emit("closeFn");
      this.$emit("refreshTable", undefined, false);
    },
    save_fn() {
      let createArr = [];

      for (let i = 0; i < this.tableData.length - 1; i++) {
        if (this.tableSelectedId.indexOf(this.tableData[i].id) >= 0) {
          let itemPayAmount = this.tableData[i].payMoney + this.tableData[i].offset.payAmount + this.tableData[i].adjustment;

          createArr.push({
            ...this.form,

            brandId: this.brandId,
            payAmount: itemPayAmount,

            accountPayableId: this.tableData[i].id,
            actualAmountResidual: this.tableData[i].actualAmountResidual,
            payMoney: this.tableData[i].payMoney,
            payDetails: this.tableData[i].payDetails,
            payableType: this.tableData[i].type,
          });
        }
      }

      createAccountPayablePayment(createArr).then(res => {
        if (res.success) {
          this.$emit("closeFn");
          this.$emit("refreshTable");
        }
      });
    },
    setSaveBtn() {
      let saveBtnDisabled = true;
      let obj = { ...this.form };
      let payMoneyTotal = this.tableData[this.tableData.length - 1].payMoney;
      let payMoneyTotalDiff = 0;
      let threeTotal = payMoneyTotal + this.tableData[this.tableData.length - 1].offset.payAmount + this.tableData[this.tableData.length - 1].adjustment;
      let { paymentTotal } = this;

      paymentTotal = parseFloat(paymentTotal.toString().replace(/[^\d-.]/g, "")) || 0;
      payMoneyTotalDiff = payMoneyTotal - paymentTotal;

      if (obj.name && obj.type && payMoneyTotalDiff == 0 && this.tableSelectedId.length > 0) {
        saveBtnDisabled = false;
      }

      this.saveBtnDisabled = saveBtnDisabled;
      this.threeTotal = threeTotal;
      this.payMoneyTotalDiff = payMoneyTotalDiff;
      this.payMoneyTotal = payMoneyTotal;
    },
    async changeType() {
      let typeDetailOption = [];
      let bankAccountId = "";
      let typeDetail = "";
      let payOffsetOption = [];
      let payOffset = {
        id: "",
        offsetDetail: "",
        offsetDetailId: "",
      };
      let bankAccountListRes;
      let accountReceivableListRes;

      switch (this.form.type) {
      case "ACCOUNT":
        bankAccountListRes = await getBankAccountList();
        typeDetailOption = bankAccountListRes.data.map(account => ({
          label: account.name,
          value: account.id
        }));
        bankAccountId = typeDetailOption[0].value || "";
        typeDetail = bankAccountId;
        break;

      case "OFFSET":
        accountReceivableListRes = await getAccountReceivableListMap(this.accountReceivablePar);
        this.setInvoiceList(accountReceivableListRes.data.data);
        typeDetailOption = accountReceivableListRes.data.data.map(item => {
          if (item.actualAmountResidual != 0) {
            return {
              value: item.id,
              label: item.name,
              child: getKeyNames(item.operationType).reduce((prev, keyName) => {
                return [...prev,
                  ...item.targetSourceList[keyName].detail.map(secItem => ({ value: secItem.uuid, label: secItem.showName }))];
              }, []),
            };
          }
        }).filter(item => item);
        this.accountReceivableOption = typeDetailOption;

        typeDetail = typeDetailOption[0].value || "";
        payOffsetOption = [ ...typeDetailOption[0].child ];
        payOffset.id = typeDetail;
        payOffset.offsetDetailId = payOffsetOption[0].value;
        payOffset.offsetDetail = payOffsetOption[0].label;

        break;

      case "CASH":
        typeDetailOption = [ ...this.typeOption[2].child ];
        typeDetail = typeDetailOption[0].value;
        break;

      default:
        break;
      }

      this.typeDetailOption = typeDetailOption;
      this.payOffsetOption = payOffsetOption;
      this.form = { ...this.form, bankAccountId, typeDetail, payOffset };
      this.setSaveBtn();
    },
    changeTypeDetail() {
      if (this.form.type == "OFFSET") {
        const id = this.form.typeDetail;
        let payOffsetOption = [];
        let payOffset = {
          id: "",
          offsetDetail: "",
          offsetDetailId: "",
        };

        for (let i = 0; i < this.accountReceivableOption.length; i++) {
          if (id == this.accountReceivableOption[i].value) {
            payOffsetOption = [ ...this.accountReceivableOption[i].child ];
            payOffset.id = id;
            payOffset.offsetDetailId = payOffsetOption[0].value;
            payOffset.offsetDetail = payOffsetOption[0].label;
            break;
          }
        }

        this.payOffsetOption = payOffsetOption;
        this.form = { ...this.form, payOffset };
      }
    },
    changePayOffset() {
      const id = this.form.payOffset.offsetDetailId;
      let offsetDetail = "";

      for (let i = 0; i < this.payOffsetOption.length; i++) {
        if (id == this.payOffsetOption[i].value) {
          offsetDetail = this.payOffsetOption[i].label;
          break;
        }
      }

      this.form.payOffset.offsetDetail = offsetDetail;
    },
    blurPaymentTotal() {
      let num = this.paymentTotal;

      num = parseFloat(num.toString().replace(/[^\d-.]/g, "")) || 0;
      num = parseInt(num * 100) / 100;

      this.paymentTotal = num;
      this.setSaveBtn();
    },
    setCellClassName({ rowIndex, columnIndex }) {
      let dataLength = this.tableData.length;

      if (rowIndex < dataLength - 1) {
        if (columnIndex >= 5) {
          return "ta-r";
        }
      }
    },
    spanMethod({ rowIndex, columnIndex }) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };
      let dataLength = this.tableData.length - 1;

      if (rowIndex == dataLength) {
        if (columnIndex == 4) {
          obj.colspan = 5;
        } else if (columnIndex >= 5) {
          obj.colspan = 1;
        } else {
          obj.colspan = 0;
        }
      }

      return obj;
    },
    selectTr(selection) {
      const that = this;
      let ids = [];
      let last_tr_payMoney = 0;
      let last_tr_actualAmountResidual = 0;
      let last_tr_adjustment = 0;
      let last_tr_offset = 0;

      selection.map(item => {
        ids.push(item.id);
      });

      for (let i = 0; i < that.tableData.length - 1; i++) {
        if (ids.indexOf(that.tableData[i].id) >= 0) {
          if (that.tableSelectedId.indexOf(that.tableData[i].id) < 0) {
            that.tableData[i].payDetails.map((item, itemIndex) => {
              that.tableData[i].payDetails[itemIndex].payMoney = item.payMoney + item.actualAmountResidual;
              // that.tableData[i].payDetails[itemIndex].actualAmountResidual = 0;
            });

            that.tableData[i].payMoney = that.tableData[i].payMoney + that.tableData[i].actualAmountResidual;
            // that.tableData[i].actualAmountResidual = 0;
          }
        } else {
          that.tableData[i].payDetails.map((item, itemIndex) => {
            that.tableData[i].payDetails[itemIndex].actualAmountResidual = item.payMoney + item.actualAmountResidual;
            that.tableData[i].payDetails[itemIndex].payMoney = 0;
          });

          that.tableData[i].actualAmountResidual = that.initTable[i].actualAmountResidual;
          that.tableData[i].payMoney = 0;
          that.tableData[i].adjustment = 0;
          that.tableData[i].payDetails = [ ...that.initTable[i].payDetails ];
          that.tableData[i].offset.payAmount = 0;
        }

        last_tr_payMoney += that.tableData[i].payMoney;
        last_tr_actualAmountResidual += that.tableData[i].actualAmountResidual;
        last_tr_adjustment += that.tableData[i].adjustment;
        last_tr_offset += that.tableData[i].offset.payAmount;
      }

      that.tableData[that.tableData.length - 1].payMoney = last_tr_payMoney;
      that.tableData[that.tableData.length - 1].actualAmountResidual = last_tr_actualAmountResidual;
      that.tableData[that.tableData.length - 1].adjustment = last_tr_adjustment;
      that.tableData[that.tableData.length - 1].offset.payAmount = last_tr_offset;
      that.tableSelectedId = ids;
      that.setSaveBtn();
    },
    async openPaymentDetailDialog(index) {
      const accountPayableId = this.tableData[index].id;

      if (this.tableSelectedId.indexOf(accountPayableId) >= 0) {
        let { name, requestDeadDateText, paymentDueDateText, needPayAmount, type } = this.tableData[index];
        let paymentInfo = {
          name: this.form.name,
          date: this.form.date,
          type: this.form.type,
          payOffset: this.form.payOffset,
          typeText: "",
          typeDetailText: "",
        };

        for (let i = 0; i < this.typeOption.length; i++) {
          if (this.form.type == this.typeOption[i].value) {
            paymentInfo.typeText = this.typeOption[i].label;
            break;
          }
        }

        for (let i = 0; i < this.typeDetailOption.length; i++) {
          if (this.form.typeDetail == this.typeDetailOption[i].value) {
            paymentInfo.typeDetailText = this.typeDetailOption[i].label;
            break;
          }
        }  
        this.setInvoiceList((await getAccountReceivableListMap(this.accountReceivablePar)).data.data);
        this.$emit(
          "openOneTimePaymentDetail",
          { name, requestDeadDateText, paymentDueDateText, type, needPayAmount: needPayAmount.toLocaleString(), itemIndex: index },
          paymentInfo,
          this.tableData[index].payDetails
        );
      }
    },
    setPaymentDetails(arr, obj) {
      const { index, adjustment, offset, payMoney } = obj;
      const lastIndex = this.tableData.length - 1;
      const { adjustment: last_adjustment, offset: last_offset, payMoney: last_payMoney } = this.tableData[lastIndex];

      // const diff_actualAmountResidual = actualAmountResidual - this.tableData[index].actualAmountResidual;
      const diff_adjustment = adjustment - this.tableData[index].adjustment;
      const diff_offset = offset - this.tableData[index].offset.payAmount;
      const diff_payMoney = payMoney - this.tableData[index].payMoney;

      this.tableData[index].payDetails = [ ...arr ];
      // this.tableData[index].actualAmountResidual = actualAmountResidual;
      this.tableData[index].adjustment = adjustment;
      this.tableData[index].offset.payAmount = offset;
      this.tableData[index].payMoney = payMoney;

      // this.tableData[lastIndex].actualAmountResidual = last_actualAmountResidual + diff_actualAmountResidual;
      this.tableData[lastIndex].adjustment = last_adjustment + diff_adjustment;
      this.tableData[lastIndex].offset.payAmount = last_offset.payAmount + diff_offset;
      this.tableData[lastIndex].payMoney = last_payMoney + diff_payMoney;

      this.threeTotal = this.tableData[lastIndex].payMoney + this.tableData[lastIndex].adjustment + this.tableData[lastIndex].offset.payAmount;
      this.payMoneyTotal = this.tableData[lastIndex].payMoney;
      this.payMoneyTotalDiff = this.tableData[lastIndex].payMoney - (parseInt(this.paymentTotal.toString().replace(/[^\d-]/g, "")) || 0);
    },
  },
  mounted() {},
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    bankAccountList: {
      type: Array,
      default: () => [],
    },
    accountReceivableList: {
      type: Array,
      default: () => [],
    },
    originalTable: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    isShow() {
      if (this.isShow) {
        let tableData = formatOneTimePaymentTableData(this.originalTable, this.typeList);

        this.form = createPaymentForm();
        this.tableData = tableData;
        this.initTable = JSON.parse(JSON.stringify(tableData));
        this.paymentTotal = "";
      }
    },
  },
  components: {
    CommDatePicker,
  },
};
</script>
